module.exports = __webpack_public_path__ + "media/react/assets/Team_icon-a232f464e0c238cff9c7b56d6b8fb7e4.svg";